import type { ReactNode } from 'react';
import { CardHeader, FiltersButton, SearchBar } from '~/components/ui';

export interface ListToolbarProps {
  title: string;
  description?: string;
  search?: {
    value: string;
    onChange: (value: string) => void;
    placeholder: string;
    debounceMs?: number;
    testId?: string;
  };
  filters?: { count: number; onClick: () => void; onClear?: () => void; testId?: string };
  /** Other right-aligned controls, after the filters. */
  actions?: ReactNode;
  /** The bulk-action bar. While set it replaces search, filters and `actions`. */
  bulk?: ReactNode;
}

/** A list card's header: the title, then search and filters, swapped for the bulk bar while rows are selected (DESIGN.md §4.5). */
export function ListToolbar({
  title,
  description,
  search,
  filters,
  actions,
  bulk,
}: ListToolbarProps) {
  return (
    <CardHeader
      title={title}
      description={description}
      actions={
        bulk ?? (
          <>
            {search && <SearchBar className="w-80" {...search} />}
            {filters && <FiltersButton {...filters} />}
            {actions}
          </>
        )
      }
    />
  );
}
